export default class Misc {
  /**
   * Returns true if the value is null or empty
   * @param value
   * @returns
   */
  static isNullOrEmpty = (value: any) => {
    if (value === null || value === undefined || value === "") {
      return true;
    }
    return false;
  };

  /**
   * Converts a number to a USD formatted string
   * @param amount
   * @returns
   */
  static convertToUSD = (amount: number): string => {
    if (this.isNullOrEmpty(amount)) return "$0.00";

    return amount.toLocaleString("en-US", {
      style: "currency",
      currency: "USD",
    });
  };

  /**
   * Returns true if the array is null or empty
   * @param arr
   * @returns
   */
  static isArrayEmpty = (arr: any[]): boolean => {
    return !Array.isArray(arr) || arr.length === 0;
  };

  /**
   * Validates email format
   */
  static validEmailFormat = (email: string): boolean => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  };

  /**
   * Validates password format
   */
  static validPasswordFormat = (password: string): boolean => {
    // Minimum eight characters, at least one uppercase letter, one lowercase letter, one number and one special character
    const passwordRegex =
      /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&#+.<>])[A-Za-z\d@$!%*?&#+.<>]{8,}$/;
    return passwordRegex.test(password);
  };

  /**
   * Formats an EIN (Employer Identification Number)
   */
  static formatEIN = (ein: string): string => {
    // Remove any non-digit characters
    const cleaned = ("" + ein).replace(/\D/g, "");

    // Format the EIN as XX-XXXXXXX
    const match = cleaned.match(/^(\d{2})(\d{7})$/);
    if (match) {
      return `${match[1]}-${match[2]}`;
    }
    return ein; // Return the original input if it doesn't match the expected format
  };

  /**
   * Formats a SSN (Social Security Number)
   */
  static formatSSN = (ssn: string): string => {
    // Remove any non-digit characters
    const cleaned = ("" + ssn).replace(/\D/g, "");

    // Format the SSN as XXX-XX-XXXX
    const match = cleaned.match(/^(\d{3})(\d{2})(\d{4})$/);
    if (match) {
      return `${match[1]}-${match[2]}-${match[3]}`;
    }
    return ssn; // Return the original input if it doesn't match the expected format
  };

  /**
   * Formats a phone number
   */
  static formatPhoneNumber = (phoneNumber: string): string => {
    // Remove any non-digit characters
    const cleaned = ("" + phoneNumber).replace(/\D/g, "");

    // Remove leading 1 if present
    const normalized =
      cleaned.length === 11 && cleaned.startsWith("1")
        ? cleaned.slice(1)
        : cleaned;

    // Format the phone number as (XXX) XXX-XXXX
    const match = normalized.match(/^(\d{3})(\d{3})(\d{4})$/);
    if (match) {
      return `(${match[1]}) ${match[2]}-${match[3]}`;
    }
    return phoneNumber; // Return the original input if it doesn't match the expected format
  };

  /**
   * Generates a username by appending a random number to the provided name
   */
  static generateUsername(name: string): string {
    const randomNum = Math.floor(Math.random() * 10000); // Generate a random number up to 9999
    return `${name}${randomNum}`;
  }

  /**
   * Shuffles an array of strings
   */
  static shuffleArray(array: any[]): any[] {
    for (let i = array.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [array[i], array[j]] = [array[j], array[i]];
    }
    return array;
  }

  /**
   * Flattens an array of objects and extracts the 'count' property, returning an array of counts
   * @param arr 
   * @returns 
   */
  static toArray = (arr: any[]) => arr.flat().map((d: any) => d.count || 0);
}
